export function useIsAndroid() {
  if (window.navigator.userAgent.startsWith("==Android==")) {
    return true;
  } else {
    return false;
  }
}
